import {
  Section,
  SectionHeader,
  SectionContent,
  FormField,
  FormMessage,
  TagInput,
  useFormContext,
} from '@predoc/cow';
import { RequestActionFormFieldProps } from './validation';

export const HIE = () => {
  const { control } = useFormContext();

  return (
    <Section className="bg-white">
      <SectionHeader>
        <h1 className="text-xl font-bold">Digital Health Data</h1>
      </SectionHeader>
      <SectionContent>
        <FormField
          control={control}
          name="HIE.alternativePostalCodes"
          render={({ field }: RequestActionFormFieldProps<'HIE'>) => (
            <div className="space-y-2">
              <TagInput
                description="Add Postal/ZIPs where this patient may have received care"
                label="Service ZIP Codes"
                onTagsChange={field.onChange}
                placeholder="ex. 12345"
                initialTags={field.value || []}
              />
              <FormMessage />
            </div>
          )}
        />
      </SectionContent>
    </Section>
  );
};
